import { render, staticRenderFns } from "./FirstBalanceForm.vue?vue&type=template&id=53ab535e"
import script from "./FirstBalanceForm.vue?vue&type=script&lang=js"
export * from "./FirstBalanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports